module.exports = __webpack_public_path__ + "img/cards2_front13.13552a09.png";